import { MijnRoute } from '../mijn-navigatie.model';

export const CHANGE_DIGITAL_ADDRESS: MijnRoute = {
    path: 'digitaal-adres-wijzigen',
    navigationEvent: 'toDigitaalAdresWijzigen',
    regex: /^\/digitaal-adres-wijzigen$/,
    webcomponent: 'mijn-digitaal-adres-wijzigen-webcomponent'
};
